import {
    GET_CONTRACTS_REQUEST,
    GET_CONTRACTS_SUCCESS,
    GET_CONTRACTS_FAILURE,
    GET_CONTRACT_REQUEST,
    GET_CONTRACT_SUCCESS,
    GET_CONTRACT_FAILURE,
    UPDATE_CONTRACT_REQUEST,
    UPDATE_CONTRACT_SUCCESS,
    UPDATE_CONTRACT_FAILURE,
    CONFIRM_CONTRACT_REQUEST,
    CONFIRM_CONTRACT_SUCCESS,
    CONFIRM_CONTRACT_FAILURE,
    DELETE_CONTRACT_REQUEST,
    DELETE_CONTRACT_SUCCESS,
    DELETE_CONTRACT_FAILURE,
    RESET_CONTRACTS_LOADED,
    COPY_CONTRACT_SUCCESS,
    COPY_CONTRACT_FAILURE,
    SET_SCHOOL_YEAR_REQUEST,
    STOP_CONTRACT_SUCCESS,
    STOP_CONTRACT_FAILURE,
    ADD_CONTRACT_SUCCESS,
    CHANGE_CONTRACT_REQUEST,
    CHANGE_CONTRACT_SUCCESS,
    CHANGE_CONTRACT_FAILURE,
    ACCEPT_CHANGE_CONTRACT_REQUEST, ACCEPT_CHANGE_CONTRACT_SUCCESS, ACCEPT_CHANGE_CONTRACT_FAILURE,
} from "../constants/contractActionTypes";
import {
    CONFIRM_EMPLOYMENT_FAILURE,
    CONFIRM_EMPLOYMENT_REQUEST,
    CONFIRM_EMPLOYMENT_SUCCESS
} from "../constants/employmentActionTypes";
import {toast} from "react-toastify";

const initialState = {
    contract: {},
    contractLoaded: false,
    contracts: [],
    contractsForStatistics: [],
    contractsLoaded: false,
    selectedSchoolYearID: 0,
    loading: {
        getContracts: false,
        getContract: false,
        updateContract: false,
        confirmContract: false,
        deleteContract: false,
        copyContract: false,
        stopContract: false,
        changeContract: false,
        acceptChangeContract: false,
    },
    error: null
}

const contractReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONTRACTS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getContracts: true },
                contractsLoaded: false,
                error: null
            };
        case GET_CONTRACTS_SUCCESS:
            return {
                ...state,
                contracts: action.payload.contracts,
                selectedSchoolYearID: action.payload.schoolYear.ID ,
                loading: { ...state.loading, getContracts: false },
                contractsLoaded: true
            };
        case GET_CONTRACTS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getContracts: false },
                error: action.payload,
                contractsLoaded: false
            };
        case ADD_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts: [...state.contracts, action.payload],
            }
        case RESET_CONTRACTS_LOADED:
            return {
                ...state,
                contractsLoaded: false,
            };
        case GET_CONTRACT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getContract: true },
                error: null,
                contractLoaded: false
            };
        case GET_CONTRACT_SUCCESS:
            return {
                ...state,
                contract: action.payload,
                contractLoaded: true,
                loading: { ...state.loading, getContract: false }
            };
        case GET_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getContract: false },
                contractLoaded: true,
                error: action.payload
            };
        case UPDATE_CONTRACT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, updateContract: true },
                error: null
            };
        case UPDATE_CONTRACT_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, updateContract: false },
                contract: {
                    ...state.contract,
                    ...action.payload.contract
                },
                contracts: state.contracts.map(contractEntry => {
                    if (contractEntry.contract.ID === action.payload.contract.ID) {
                        return {
                            ...contractEntry,
                            contract: {
                                ...contractEntry.contract,
                                ...action.payload.contract
                            }
                        };
                    }
                    return contractEntry;
                })
            };
        case UPDATE_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, updateContract: false },
                error: action.payload
            };
        case CONFIRM_CONTRACT_REQUEST:
            toast("LOADING", {type: "info"});
            return {
                ...state,
                loading: { ...state.loading, confirmContract: true },
                error: null
            };
        case CONFIRM_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts: state.contracts.map(contractEntry => {
                    if (contractEntry.contract.ID === action.payload.contract.ID) {
                        return {
                            ...contractEntry,
                            contract: {
                                ...contractEntry.contract,
                                ...action.payload.contract
                            }
                        };
                    }
                    return contractEntry;
                }).filter(contractEntry => contractEntry.contract.Status !== 'NONE')
            };
        case CONFIRM_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, confirmContract: false },
                error: action.payload
            };
        case CHANGE_CONTRACT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, changeContract: true },
                error: null
            };
        case CHANGE_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts: state.contracts.map(contractEntry => {
                    if (contractEntry.contract.ID === action.payload.contract.ID) {
                        return {
                            ...contractEntry,
                            contract: {
                                ...contractEntry.contract,
                                ...action.payload.contract
                            }
                        };
                    }
                    return contractEntry;
                })
            };
        case CHANGE_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, changeContract: false },
                error: action.payload
            };
        case ACCEPT_CHANGE_CONTRACT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, acceptChangeContract: true },
                error: null
            };
        case ACCEPT_CHANGE_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts: state.contracts.map(contractEntry => {
                    if (contractEntry.contract.ID === action.payload.contract.ID) {
                        return {
                            ...contractEntry,
                            contract: {
                                ...contractEntry.contract,
                                ...action.payload.contract
                            }
                        };
                    }
                    return contractEntry;
                })
            };
        case ACCEPT_CHANGE_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, acceptChangeContract: false },
                error: action.payload
            };
        case DELETE_CONTRACT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, deleteContract: true },
                error: null
            };
        case DELETE_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts: state.contracts.filter(contractEntry => contractEntry.contract.ID !== action.payload),
                loading: { ...state.loading, deleteContract: false }
            };
        case DELETE_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, deleteContract: false },
                error: action.payload
            };
        case COPY_CONTRACT_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, copyContract: false },
                error: action.payload
            };
        case COPY_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, copyContract: false },
                error: action.payload
            };
        case SET_SCHOOL_YEAR_REQUEST:
            return {
                ...state,
                selectedSchoolYearID: action.payload,
                error: null
            };
        case CONFIRM_EMPLOYMENT_REQUEST:
            toast("LOADING", {type: "info"});
            return {
                ...state,
                loading: { ...state.loading, confirmEmployment: true },
                error: null
            };
        case CONFIRM_EMPLOYMENT_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, confirmEmployment: false },
                contracts: state.contracts.map(contractEntry => {
                    if (contractEntry.contract.ID === action.payload.contract.ID) {
                        return {
                            ...contractEntry,
                            contract: {
                                ...contractEntry.contract,
                                Status: action.payload.contract.Status
                            },
                            employments: contractEntry.employments.map(employmentEntry => {
                                if (employmentEntry.employment.ID === action.payload.employment.ID) {
                                    return {
                                        ...employmentEntry,
                                        employment: {...employmentEntry.employment, ...action.payload.employment}
                                    };
                                }
                                return employmentEntry;
                            })
                        };
                    }
                    return contractEntry;
                })
            };
        case CONFIRM_EMPLOYMENT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, confirmEmployment: false },
                error: action.payload
            };
        case STOP_CONTRACT_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, stopContract: false },
                contracts: state.contracts.map(contractEntry => {
                    if (contractEntry.contract.ID === action.payload.contract.ID) {
                        return {
                            ...contractEntry,
                            contract: {
                                ...contractEntry.contract,
                                ...action.payload.contract
                            }
                        };
                    }
                    return contractEntry;
                })
            }
        case STOP_CONTRACT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, stopContract: false },
                error: action.payload
            };
        default:
            return state;
    }
}

export default contractReducer;